<!-- Copyright (c) 2025 Digital Systems (M) Sdn. Bhd. -->

<template>
  <div class="main">
    <Menus :menu="menus" @menuClicked="menuClicked" />
    <div class="listing-container">
      <div class="sst-status">
        <!-- <div class="acc-health" v-if="false">
          <div
            >Account Validation: {{ validateHealth ? 'Pass' : 'Fail' }}
            <img v-if="validateHealth" src="https://dsmlib.logistics.systems/Icons/Save.png" alt="" height="20" />
            <img v-else src="https://dsmlib.logistics.systems/Icons/icons8-close-90.png" alt="" height="20" />
          </div>
          <Button @click="validatePopupOpen = true">View Details</Button>
        </div> -->
        <div class="filter ml-auto">
          <div v-if="listStartDateActive && listEndDateActive"
            >Date: {{ listStartDateActive }} to {{ listEndDateActive }}</div
          >
          <div v-else>No Active Filters</div>
          <ButtonFilter buttonText="Change Filter" filterPosition="right" :filterWidth="220" :isOpen.sync="filterOpen">
            <div class="d-flex flex-column">
              <BoxContainer title="Date" class="d-flex">
                <DateTimePicker placeholder="From" :value.sync="listStartDate" :showTime="false" />
                <DateTimePicker placeholder="To" :value.sync="listEndDate" :showTime="false" />
              </BoxContainer>
              <Button class="ml-auto mt-2" @click="filterRefreshClick">Refresh</Button>
            </div>
          </ButtonFilter>
        </div>
      </div>
      <TableBox
        :tableData="SSTListTableData"
        :loading="SSTListTableLoading"
        title="SST Return List"
        :selectedRow.sync="SSTListTableSelectedRows"
        class="sst-table"
        :dataType="SSTListTableDataType"
      />
    </div>

    <!-- <div class="validate-popup" v-if="validatePopupOpen && false">
      <div class="validate-popup-inner">
        <TableBox :title="validateTitle" :tableData="validateTableData" :columnWidth="[32, 120, 84, 360, 140]" />
        <Button @click="validatePopupOpen = false">Close</Button>
      </div>
    </div> -->
    <PopupV2
      :show="periodStartPopup"
      title="Enter Taxable Period Start Date"
      :buttons="periodStartPopupButtons"
      @buttonClicked="periodStartPopupClick"
    >
      <div class="d-flex flex-column align-items-center period-popup">
        <DateTimePicker
          placeholder="Start Date"
          :value.sync="periodStartValue"
          :showTime="false"
          :errorMessage.sync="periodStartValueError"
        />
        <DateTimePicker plaeholder="End Date" :value.sync="periodEndValue" :isDisabled="true" :showTime="false" />

        <div v-if="checkPeriodError" class="text-danger">{{ checkPeriodError }}</div>
      </div>
    </PopupV2>
    <PopupEntry
      v-if="popupEntryShow"
      :show.sync="popupEntryShow"
      :title="popupEntryTitle"
      @save="popupSave"
      @update:show="popupCancel"
      :successMessages="entrySuccess"
      :errorMessages="entryError"
      :viewMode="viewMode"
    >
      <div class="d-flex h-100">
        <Tab
          class="tab-component"
          :tabs="tabItems"
          :tabIndex.sync="selectedTabIndex"
          :preventTabSwitch="true"
          @tabClicked="tabClick"
        >
          <div class="tab-container" :slot="partATabName">
            <div class="form-container">
              <div class="flex-container w-100 align-items-center">
                <div style="min-width: 160px"> Filling No. </div>
                <Input placeholder="Filing No." :inputValue.sync="fillingNoValue" :isDisabled="true" />
              </div>
              <div class="flex-container w-100 align-items-center">
                <div style="min-width: 160px"> Journal Batch No. </div>
                <Input placeholder="Journal Batch No." :inputValue.sync="journalBatchNoValue" :isDisabled="true" />
              </div>
              <div class="grid-form partA mb-2 mt-3">
                <div></div>
                <div style="font-weight: bold; text-decoration: underline; text-align: center">SALES TAX</div>
                <div style="font-weight: bold; text-decoration: underline; text-align: center">SERVICE TAX</div>
              </div>
              <div class="grid-form partA">
                <div>1) SST Registration No.*</div>
                <div
                  ><Input placeholder="" :inputValue.sync="SSTRegistrationNoSalesValue" :isDisabled="viewMode"
                /></div>
                <div
                  ><Input placeholder="" :inputValue.sync="SSTRegistrationNoServiceValue" :isDisabled="viewMode"
                /></div>
              </div>
              <div class="grid-form partA">
                <div>2) Name of Business.*</div>
                <div style="grid-column: span 2"
                  ><Input placeholder="" :inputValue.sync="nameOfBusinessValue" :isDisabled="viewMode"
                /></div>
              </div>
              <div class="grid-form partA">
                <div>3) Taxable Period.*</div>
                <div
                  ><DateTimePicker
                    placeholder="Start Date"
                    :showTime="false"
                    :isDisabled="true"
                    :value.sync="periodStartValue"
                /></div>
                <div
                  ><DateTimePicker
                    placeholder="End Date"
                    :showTime="false"
                    :isDisabled="true"
                    :value.sync="periodEndValue"
                /></div>
              </div>
              <div class="grid-form partA">
                <div>4) Return and Payment Due Date.*</div>
                <div style="grid-column: span 2"
                  ><DateTimePicker
                    placeholder="Due Date"
                    :value.sync="returnDueDateValue"
                    :showTime="false"
                    :isDisabled="true"
                /></div>
              </div>
            </div>
          </div>
          <div class="tab-container h-100" :slot="partB1TabName">
            <div class="d-flex h-100">
              <TableBox :tableData="b1Details" style="min-width: 0" :dataType="b1DetailsDataType" />
            </div>
          </div>
          <div class="tab-container" :slot="partB2TabName">
            <div class="form-container">
              <div class="grid-form partB2 align-items-start mb-2">
                <div>11)</div>
                <div>Total Value of Sales and Tax Payable As Per Tax Rate.*</div>
                <div></div>
                <div style="text-align: center; text-wrap: balance"
                  >Value of Taxable Sales / Service / No. of Cards</div
                >
                <div style="text-align: center; text-wrap: balance">Tax Rate</div>
                <div></div>
                <div style="text-align: center; text-wrap: balance">Value of Tax Payable</div>
              </div>
              <div class="grid-form partB2">
                <div></div>
                <div>11a) Taxable Goods at 5% Rate.</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b211aValue)" textAlign="right"
                /></div>
                <div><Input placeholder="" :isDisabled="true" inputValue="5%" textAlign="center" /></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(b211aCalcValue)"
                    textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2">
                <div></div>
                <div>11b) Taxable Goods at 10% Rate.</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b211bValue)" textAlign="right"
                /></div>
                <div><Input placeholder="" :isDisabled="true" inputValue="10%" textAlign="center" /></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(b211bCalcValue)"
                    textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2">
                <div></div>
                <div>11c) Taxable Services at 6% Rate.</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b211cValue)" textAlign="right"
                /></div>
                <div><Input placeholder="" :isDisabled="true" inputValue="6%" textAlign="center" /></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(b211cCalcValue)"
                    textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2">
                <div></div>
                <div>11d) Taxable Services at 8% Rate.</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b211dValue)" textAlign="right"
                /></div>
                <div><Input placeholder="" :isDisabled="true" inputValue="8%" textAlign="center" /></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(b211dCalcValue)"
                    textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2">
                <div></div>
                <div>11e) Taxable Services Item 1, Group H.*</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b211eValue)" textAlign="right"
                /></div>
                <div><Input placeholder="" :isDisabled="true" inputValue="MYR 25" textAlign="center" /></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(b211eCalcValue)"
                    textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2 my-3">
                <div>12)</div>
                <div>Total Value of Tax Payable.* (11a + 11b) OR (11c + 11d + 11e)</div>
                <div></div>
                <div></div>
                <div></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b212Value)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2">
                <div>13)</div>
                <div>Amount of Tax Deduction</div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
              <div class="grid-form partB2">
                <div></div>
                <div>13a) Tax Deduction from Credit Note</div>
                <div></div>
                <div></div>
                <div></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b213aValue)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2">
                <div></div>
                <div>13b) Sales Tax Deduction</div>
                <div></div>
                <div></div>
                <div></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b213bValue)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2">
                <div></div>
                <div>13c) Service Tax Deduction</div>
                <div></div>
                <div></div>
                <div></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b213cValue)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2">
                <div></div>
                <div>13d) Total Tax Value of Bad Debt Relief</div>
                <div></div>
                <div></div>
                <div></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b213dValue)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2">
                <div>13A)</div>
                <div>Adjustment under Sales Tax Deduction</div>
                <div></div>
                <div></div>
                <div></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b213AValue)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2 mt-2">
                <div>14)</div>
                <div>Total Tax Payable Before Penalty Imposed.* (12 - 13a - 13b - 13c - 13A)</div>
                <div></div>
                <div></div>
                <div></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(b214Value)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partB2 mt-2">
                <div>15)</div>
                <div>Penalty Rate / Penalty Amount.</div>
                <div></div>
                <div></div>
                <div class="d-flex"
                  ><Input
                    placeholder=""
                    :inputValue.sync="b215RateValue"
                    textAlign="center"
                    validator="positiveInteger,3"
                    :isDisabled="viewMode"
                    @focusChanged="calculateB2PenaltyTotalPercent"
                  />%</div
                >
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :inputValue.sync="b215Value"
                    textAlign="right"
                    validator="positiveMoney"
                    :isDisabled="viewMode"
                    @focusChanged="calculateB2PenaltyTotalAmt"
                /></div>
              </div>
              <div class="grid-form partB2 mt-2">
                <div>16)</div>
                <div>Total Tax Payable Inclusive of Penalty.* (14 + 15)</div>
                <div></div>
                <div></div>
                <div></div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(b216realTotal)"
                    textAlign="right"
                /></div>
              </div>
            </div>
          </div>
          <div class="tab-container" :slot="partCTabName">
            <div class="form-container">
              <div class="grid-form partC">
                <div>17)</div>
                <div style="grid-column: 2 / -1">Total Value of Tax Payable as per rate of tax.</div>
              </div>
              <div class="grid-form partC mb-2">
                <div></div>
                <div style="grid-column: 2 / 6"></div>
                <div style="text-align: center">Sold Quantity</div>
                <div style="text-align: center">Value of Taxable Sales</div>
                <div style="text-align: center">Value of Tax Payable</div>
              </div>
              <div class="grid-form partC">
                <div></div>
                <div>At Rate</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(c17LitreRate)"
                    textAlign="right"
                /></div>
                <div>Per Litre.*</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(c17LitreQty)"
                    textAlign="right"
                /></div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(c17LitreSales)"
                    textAlign="right"
                /></div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(c17LitrePayable)"
                    textAlign="right"
                /></div>
              </div>
              <div class="grid-form partC">
                <div></div>
                <div>At Rate</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(c17KilogramRate)"
                    textAlign="right"
                /></div>
                <div>Per Kilogram.*</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(c17KilogramQty)"
                    textAlign="right"
                /></div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(c17KilogramSales)"
                    textAlign="right"
                /></div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(c17KilogramPayable)"
                    textAlign="right"
                /></div>
              </div>
              <div class="grid-form partC">
                <div></div>
                <div>At Rate</div>
                <div style="text-align: end">%</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(c17VolRate)" textAlign="right"
                /></div>
                <div>ad-volreum.*</div>
                <div></div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(c17VolSales)"
                    textAlign="right"
                /></div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(c17VolPayable)"
                    textAlign="right"
                /></div>
              </div>
            </div>
          </div>
          <div class="tab-container" :slot="partDTabName">
            <div class="form-container">
              <div class="grid-form partD mt-3">
                <div style="grid-column: 1/-1">18) Sales of Taxable Goods / Taxable Services.*</div>
              </div>
              <div class="grid-form partD">
                <div></div>
                <div>18a)</div>
                <div style="grid-column: 3/-3">Export / Special Area / Designated Area.*</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(d18aValue)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partD mt-3">
                <div></div>
                <div>18b)</div>
                <div style="grid-column: 3/-1"
                  >Local sales exempted to person under the Sales Tax (Person Exempted From Payment of Sales Tax) Order
                  2018:*</div
                >
              </div>
              <div class="grid-form partD">
                <div style="grid-column: 1/3"></div>
                <div>1)</div>
                <div style="grid-column: 4/-3">Schedule A (Class of Person).*</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(d18b1Value)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partD">
                <div style="grid-column: 1/3"></div>
                <div>2)</div>
                <div style="grid-column: 4/-3">Schedule B (Manufacturer of specific non-taxable goods).*</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(d18b2Value)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partD">
                <div style="grid-column: 1/3"></div>
                <div>3)</div>
                <div style="grid-column: 4/-1">Schedule C (Registered Manufacturer).*</div>
              </div>
              <div class="grid-form partD">
                <div style="grid-column: 4/5">i)</div>
                <div style="grid-column: 5/-3"
                  >Item 1 and 2 (Purchase / Importation of Raw Materials / Components / Packaging Materials Exempted
                  From Sales Tax).*</div
                >
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(d18b3iValue)"
                    textAlign="right"
                /></div>
              </div>
              <div class="grid-form partD">
                <div style="grid-column: 4/5">ii)</div>
                <div style="grid-column: 5/-3"
                  >Item 3 and 4 (Purchase / Importation of Raw Materials / Components / Packaging Materials on behalf
                  of Registered Manufacturer Exempted From Sales Tax).*</div
                >
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(d18b3iiValue)"
                    textAlign="right"
                /></div>
              </div>
              <div class="grid-form partD">
                <div style="grid-column: 4/5">iii)</div>
                <div style="grid-column: 5/-3">Item 5 (Value of Work Performed Exempted From Sales Tax).*</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :isDisabled="true"
                    :inputValue="$currencyFormat(d18b3iiiValue)"
                    textAlign="right"
                /></div>
              </div>
              <div class="grid-form partD mt-3">
                <div></div>
                <div>18c)</div>
                <div style="grid-column: 3/-1">Value of Exempted Taxable Services.*</div>
              </div>
              <div class="grid-form partD">
                <div style="grid-column: 1/3"></div>
                <div>1)</div>
                <div style="grid-column: 4/-3">Provision of registered person to registered person (B2B).*</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :inputValue.sync="d18c1Value"
                    textAlign="right"
                    validator="positiveMoney"
                    :isDisabled="viewMode"
                /></div>
              </div>
              <div class="grid-form partD">
                <div style="grid-column: 1/3"></div>
                <div>2)</div>
                <div style="grid-column: 4/-3">Group relief.*</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :inputValue.sync="d18c2Value"
                    textAlign="right"
                    validator="positiveMoney"
                    :isDisabled="viewMode"
                /></div>
              </div>
              <div class="grid-form partD">
                <div style="grid-column: 1/3"></div>
                <div>3)</div>
                <div style="grid-column: 4/-3">Other exemption.*</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :inputValue.sync="d18c3Value"
                    textAlign="right"
                    validator="positiveMoney"
                    :isDisabled="viewMode"
                /></div>
              </div>
              <div class="grid-form partD mt-3">
                <div></div>
                <div>18d)</div>
                <div style="grid-column: 3/-3">Total Value of Non-Taxable Services.*</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :inputValue.sync="d18dValue"
                    textAlign="right"
                    validator="positiveMoney"
                    :isDisabled="viewMode"
                /></div>
              </div>
              <div class="grid-form partD mt-3">
                <div></div>
                <div>18e)</div>
                <div style="grid-column: 3/-3"
                  >Total Value of Sales Exempted Under Subsection 35(3) and / or Section 61A Sales Tax Act 2018.*</div
                >
                <div style="text-align: end">MYR</div>
                <div
                  ><Input
                    placeholder=""
                    :inputValue.sync="d18eValue"
                    textAlign="right"
                    validator="positiveMoney"
                    :isDisabled="viewMode"
                /></div>
              </div>
            </div>
          </div>
          <div class="tab-container" :slot="partETabName"
            ><div class="form-container">
              <div class="grid-form partE">
                <div>19)</div>
                <div>Item 1 and 2 (Purchase / Importation of Raw Materials / Components / Packaging Materials Exempted From Sales Tax).*</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(e19Value)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partE mt-3">
                <div>20)</div>
                <div
                  >Item 3 and 4 (Purchase / Importation of Raw Materials / Components / Packaging Materials on behalf
                  of Registered Manufacturer Exempted From Sales Tax).*</div
                >
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(e20Value)" textAlign="right"
                /></div>
              </div>
              <div class="grid-form partE mt-3">
                <div>21)</div>
                <div>Item 5 (Value of Work Performed Exempted from Sales Tax).*</div>
                <div style="text-align: end">MYR</div>
                <div
                  ><Input placeholder="" :isDisabled="true" :inputValue="$currencyFormat(e21Value)" textAlign="right"
                /></div>
              </div> </div
          ></div>
          <div class="tab-container" :slot="partFTabName">
            <div class="form-container">
              <div class="grid-form partF">
                <div>22)</div>
                <div>Date</div>
                <div
                  ><DateTimePicker :showTime="false" placeholder="" :value.sync="f22Value" :isDisabled="viewMode"
                /></div>
              </div>
              <div class="grid-form partF">
                <div>23)</div>
                <div>Name of Declarant.</div>
                <div style="grid-column: 3/-1"
                  ><Input placeholder="" :inputValue.sync="f23Value" :isDisabled="viewMode"
                /></div>
              </div>
              <div class="grid-form partF">
                <div>24)</div>
                <div>Identity Card / Passport No.</div>
                <div><Input placeholder="" :inputValue.sync="f24Value" :isDisabled="viewMode" /></div>
              </div>
              <div class="grid-form partF">
                <div>25)</div>
                <div>Designation of Declarant.</div>
                <div style="grid-column: 3/-1"
                  ><Input placeholder="" :inputValue.sync="f25Value" :isDisabled="viewMode"
                /></div>
              </div>
              <div class="grid-form partF">
                <div>26)</div>
                <div>Telephone No.</div>
                <div><Input placeholder="" :inputValue.sync="f26Value" :isDisabled="viewMode" /></div>
              </div>
            </div>
          </div>
        </Tab>
      </div>
    </PopupEntry>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    menus() {
      return [
        {
          title: 'New SST Return',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-add-new-50.png',
          key: 'New',
          visible: true,
          control: '',
        },
        {
          title: 'Edit SST Return',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64%20(1).png',
          key: 'Edit',
          visible: true,
          control: '',
        },
        {
          title: 'Delete SST Return',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-reduce-50.png',
          key: 'Delete',
          visible: true,
        },
        {
          title: 'View SST Return',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          key: 'View',
          visible: true,
        },
        {
          title: 'Print SST Return',
          icon: 'https://dsmlib.logistics.systems/Icons/Print.png',
          key: 'Print',
          visible: true,
        },
      ];
    },
    // validateTitle() {
    //   return `Validated Account Validation (${this.validateStartDateActive} to ${this.validateEndDateActive})`;
    // },
    // validateHealth() {
    //   const findNotPass = this.validateTableData.find((item) => item.Solved == '0');
    //   return !findNotPass;
    // },
    SSTNextFillingDate() {
      const effDate = this.SSTDetails?.SSTNextFillingDate ? new Date(this.SSTDetails?.SSTNextFillingDate) : null;
      return effDate;
    },

    SSTEffectiveDate() {
      const effDate = this.SSTDetails?.SSTEffectiveDate ? new Date(this.SSTDetails?.SSTEffectiveDate) : null;
      return effDate;
    },

    popupEntryTitle() {
      return `${this.menuMode} SST Return`;
    },

    tabItems() {
      return [
        { title: this.partATabName },
        { title: this.partB1TabName },
        { title: this.partB2TabName },
        { title: this.partCTabName },
        { title: this.partDTabName },
        { title: this.partETabName },
        { title: this.partFTabName },
      ];
    },

    periodEndValue() {
      if (this.periodEndValueOverride) return this.periodEndValueOverride;

      const startDate = this.periodStartValue;
      const endDate = startDate ? new Date(startDate.getFullYear(), startDate.getMonth() + 2, 0) : null;
      return endDate;
    },

    b216realTotal() {
      return this.toSSTNumber(this.b214Value) + this.toSSTNumber(this.b215Value);
    },

    currencyFormatState() {
      return this.$store.state.currencyFormat;
    },
  },
  data: function () {
    return {
      // validateStartDate: null,
      // validateEndDate: null,

      // validateStartDateActive: '',
      // validateEndDateActive: '',

      // validateTableData: [],
      // validatePopupOpen: true,

      filterOpen: false,

      listStartDate: new Date(new Date().getFullYear(), 0, 1),
      listEndDate: new Date(new Date().getFullYear(), 11, 31),

      listStartDateActive: null,
      listEndDateActive: null,

      SSTDetails: null,

      SSTListTableData: [],
      SSTListTableLoading: false,
      SSTListTableSelectedRows: [],

      SSTListTableDataType: {
        '#': 'number',
        'Filling No': 'string',
        'Filling Date': 'date',
        'Period Start Date': 'date',
        'Period End Date': 'date',
        'Tax Payable': 'currency',
        'Amt Deduct Fr Credit Note': 'currency',
        'Penalty Amt': 'currency',
        'Total Payable Incl Penalty': 'currency',
        Remarks: 'string',
        'User Created': 'string',
        'Date Created': 'date',
        'User Updated': 'string',
        'Date Updated': 'date',
      },

      periodStartPopup: false,
      periodStartPopupButtons: [{ text: 'OK' }, { text: 'Cancel', color: 'lightgray' }],

      popupEntryShow: false,
      menuMode: '',
      entrySuccess: [],
      entryError: [],
      viewMode: false,

      partATabName: 'Part A: Registered Manufacturer / Person Particulars',
      partB1TabName: 'Part B1: Sales / Service Details',
      partB2TabName:
        'Part B2: Value of Tax Payable for Goods (Sales, Disposed, Own Use) / Services (Services Performed / Own Use)',
      partCTabName: 'Part C: Goods under Schedule 2, Sales Tax Order',
      partDTabName: 'Part D: Sales / Services Exempted from Tax / Non-Taxable Service',
      partETabName: 'Part E: Purchase under the Schedule C, Sales Tax Order',
      partFTabName: 'Part F: Declarations',

      selectedTabIndex: 0,

      periodStartValueError: '',

      periodStartValue: null,
      periodEndValueOverride: null,
      checkPeriodError: '',

      fillingNoValue: '',
      journalBatchNoValue: '',
      SSTRegistrationNoSalesValue: '',
      SSTRegistrationNoServiceValue: '',
      nameOfBusinessValue: '',
      returnDueDateValue: null,

      b1Details: [],

      b1DetailsDataType: {
        '#': 'number',
        'Tax Goods/Service Desc': 'string',
        'Tariff Code/Service Code': 'string',
        'Val of Tax Goods Sold/Work Performed': 'currency',
        'Val of Goods Own Used/Disposed/Free Services': 'currency',
        'Val of Tax Services': 'currency',
        'Tax Payable': 'currency',
        'Tax Deduct fr CN': 'currency',
        'Tax Exempted': 'currency',
      },

      b211aValue: 0,
      b211bValue: 0,
      b211cValue: 0,
      b211dValue: 0,
      b211eValue: 0,

      b211aCalcValue: 0,
      b211bCalcValue: 0,
      b211cCalcValue: 0,
      b211dCalcValue: 0,
      b211eCalcValue: 0,

      b212Value: 0,

      b213aValue: 0,
      b213bValue: 0,
      b213cValue: 0,
      b213dValue: 0,

      b213AValue: 0,

      b214Value: 0,
      b215RateValue: '0',
      b215Value: 0,
      b216Value: 0,

      c17LitreRate: 0,
      c17LitreQty: 0,
      c17LitreSales: 0,
      c17LitrePayable: 0,

      c17KilogramRate: 0,
      c17KilogramQty: 0,
      c17KilogramSales: 0,
      c17KilogramPayable: 0,

      c17VolRate: 0,
      c17VolSales: 0,
      c17VolPayable: 0,

      d18aValue: 0,
      d18b1Value: 0,
      d18b2Value: 0,

      d18b3iValue: 0,
      d18b3iiValue: 0,
      d18b3iiiValue: 0,

      d18c1Value: this.$currencyFormat('0'),
      d18c2Value: this.$currencyFormat('0'),
      d18c3Value: this.$currencyFormat('0'),

      d18dValue: this.$currencyFormat('0'),
      d18eValue: this.$currencyFormat('0'),

      e19Value: 0,
      e20Value: 0,
      e21Value: 0,

      f22Value: null,
      f23Value: '',
      f24Value: '',
      f25Value: '',
      f26Value: '',
    };
  },
  props: {},
  methods: {
    // async getAccountHealth() {
    //   const startDate = new Date(2019, 2, 1).formatString('yyyy-MM-dd');
    //   const endDate = new Date(2019, 4, 1).formatString('yyyy-MM-dd');
    //   // const startDate = this.validateStartDate.formatString('yyyy-MM-dd');
    //   // const endDate = this.validateEndDate.formatString('yyyy-MM-dd');

    //   const result = await this.$apiCallV2('/SSTReturn/CheckAccountHealth', {
    //     startdate: startDate,
    //     enddate: endDate,
    //   });

    //   const filter = result.map((item) => {
    //     const { RowID, DocNo, DocType, Details, Solved } = item;
    //     return {
    //       '#': RowID,
    //       'Doc No': DocNo,
    //       'Doc Type': DocType,
    //       Resolution: Details,
    //       Action: Solved == '1' ? 'Solved' : 'Requires Action',
    //     };
    //   });
    //   this.validateTableData = [];
    //   this.$nextTick(() => {
    //     this.validateTableData = filter ?? [];
    //   });

    //   this.validateStartDateActive = startDate;
    //   this.validateEndDateActive = endDate;
    // },

    async menuClicked(e) {
      this.menuMode = e.key;
      this.viewMode = false;

      const { 'Filling No': selectedFillingno } = this.SSTListTableSelectedRows?.[0] || {};

      switch (this.menuMode) {
        case 'New':
          this.$fullscreenLoading('Getting SST Details');
          await this.getSSTDetails();
          this.clearPeriodPopupError();

          this.periodStartValue = this.SSTNextFillingDate ?? this.SSTEffectiveDate ?? null;
          this.periodStartPopup = true;
          this.$fullscreenLoading();
          break;

        case 'Edit':
          if (this.SSTListTableSelectedRows.length < 1) {
            this.$showAlert('error', 'No SST Return is selected', 'Please select a SST Return to Edit');
            break;
          }
          this.popupEntryOpen(selectedFillingno);
          break;

        case 'View':
          if (this.SSTListTableSelectedRows.length < 1) {
            this.$showAlert('error', 'No SST Return is selected', 'Please select a SST Return to View');
            break;
          }
          this.viewMode = true;
          this.popupEntryOpen(selectedFillingno);
          break;

        case 'Delete': {
          if (this.SSTListTableSelectedRows.length < 1) {
            this.$showAlert('error', 'No SST Return is selected', 'Please select a SST Return to Delete');
            break;
          }
          const discard = await this.$showAlert('warning', 'Are you sure you want to delete this SST Return?', '', [
            { text: 'Delete', color: 'Red', textColor: 'white' },
            { text: 'Cancel' },
          ]);
          if (discard === 'Cancel') return false;

          this.$fullscreenLoading('Deleting SST Return');

          const result = await this.$apiCallV2('/SSTReturn/SaveSSTReturn', {
            fillingno: selectedFillingno,
            delete: 'Y',
          });
          const { Results, ErrMsg, fillingno } = result?.[0] || {};

          if (Results == '0') {
            this.$showAlert('success', `SST Return ${fillingno} Deleted`, ErrMsg, [{ text: 'OK' }]);
          } else {
            this.$showAlert('error', 'SST Return Could Not Be Deleted', ErrMsg, [{ text: 'OK' }]);
          }

          await this.GetSSTReturnList();
          this.$fullscreenLoading();

          break;
        }
        case 'Print': {
          const print = this.$router.resolve(
            `/Home/${this.$route.params.user}/FINGL/PrintSSTReturn${selectedFillingno ? `?fillingno=${selectedFillingno}` : ''}`,
          );

          window.open(print.href, '_blank');
          break;
        }

        default:
          break;
      }
    },

    tabClick(_tabItem, tabIndex) {
      this.selectedTabIndex = tabIndex;
    },

    async filterRefreshClick() {
      this.$fullscreenLoading('Getting SST List');
      await this.GetSSTReturnList();
      this.$fullscreenLoading();
      this.filterOpen = false;
    },

    clearPeriodPopupError() {
      this.checkPeriodError = '';
      this.periodStartValueError = '';
    },

    parseSSTDate(value) {
      if (!value) return null;
      if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

      const dateText = String(value).trim().split(/[T ]/)[0];
      const ymd = dateText.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);
      const dmy = dateText.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
      const year = ymd ? Number(ymd[1]) : dmy ? Number(dmy[3]) : NaN;
      const month = ymd ? Number(ymd[2]) : dmy ? Number(dmy[2]) : NaN;
      const day = ymd ? Number(ymd[3]) : dmy ? Number(dmy[1]) : NaN;

      if (![year, month, day].every(Number.isFinite)) return null;

      const date = new Date(year, month - 1, day);
      return date.getFullYear() == year && date.getMonth() == month - 1 && date.getDate() == day ? date : null;
    },

    toSSTNumber(value) {
      const number = this.$currencyToNumber(value);
      return Number.isFinite(number) ? number : 0;
    },

    clearPopupText() {
      this.entrySuccess = [];
      this.entryError = [];
    },

    async periodStartPopupClick(text) {
      this.clearPeriodPopupError();
      if (text == 'OK') {
        if (!this.periodStartValue) {
          this.periodStartValueError = 'Start Date is required';
          return;
        }

        this.$fullscreenLoading('Checking SST Period');
        const { Results: checkResult, ErrMsg: checkErr } = await this.checkSSTPeriod();
        if (checkResult == '1') {
          this.checkPeriodError = checkErr;

          this.$fullscreenLoading();
          return;
        }
        this.periodStartPopup = false;

        this.popupEntryOpen();
      } else if (text == 'Cancel') {
        this.periodStartPopup = false;
      }
    },

    popupEntryOpen(fillingno) {
      this.selectedTabIndex = 0;
      this.clearPopupText();
      this.clearPopupEntryFields();
      this.popupEntryShow = true;
      this.populatePopupEntry(fillingno);
    },

    async populatePopupEntry(fillingno) {
      this.$fullscreenLoading('Getting SST Return Details');

      let sst = {};

      if (fillingno) sst = this.parseSSTXML(await this.getSSTReturnsDetail(fillingno)) ?? {};
      else sst = await this.getSSTReturns();

      const {
        FillingNo,
        CompanyName,
        SalesTaxLicenseNo,
        ServiceTaxLicenseNo,
        ReturnPaymentDueDate,
        TaxPeriodStartDate,
        TaxPeriodEndDate,
      } = sst;

      this.fillingNoValue = FillingNo;
      this.nameOfBusinessValue = CompanyName || '';
      this.SSTRegistrationNoSalesValue = SalesTaxLicenseNo || '';
      this.SSTRegistrationNoServiceValue = ServiceTaxLicenseNo || '';

      this.periodStartValue = this.parseSSTDate(TaxPeriodStartDate);
      this.periodEndValueOverride = this.parseSSTDate(TaxPeriodEndDate);
      const periodEndDate = this.periodEndValue;
      const parsedReturnDueDate = this.parseSSTDate(ReturnPaymentDueDate);
      this.returnDueDateValue =
        parsedReturnDueDate ||
        (periodEndDate ? new Date(periodEndDate.getFullYear(), periodEndDate.getMonth() + 2, 0) : null);

      const detailsList = [];

      for (let n = 1; n <= 10; n++) {
        const desc = sst[`TaxItemDesc${n}`];
        if (desc !== null && desc !== undefined) {
          const getVal = (key) => sst[key] ?? 0;

          detailsList.push({
            '#': n,
            'Tax Goods/Service Desc': (desc ?? '').trim(),
            'Tariff Code/Service Code': (sst[`TaxItemTariffCode${n}`] ?? '').trim(),
            'Val of Tax Goods Sold/Work Performed': getVal(`ValofTaxGoods${n}`),
            'Val of Goods Own Used/Disposed/Free Services': getVal(`ValofGoodsOwnUse${n}`),
            'Val of Tax Services': getVal(`ValTaxServices${n}`),
            'Tax Payable': getVal(`TaxPayable${n}`),
            'Tax Deduct fr CN': getVal(`AmtDeductCN${n}`),
            'Tax Exempted': getVal(`TotalValExempted${n}`),
          });
        }
      }

      const {
        TotalValTaxablePerc5,
        TotalValTaxablePerc10,
        TotalValTaxablePerc6,
        TotalValTaxablePerc8,
        TotalUnitTaxableRM25,
        TotalValTaxPayablePerc5,
        TotalValTaxPayablePerc10,
        TotalValTaxPayablePerc6,
        TotalValTaxPayablePerc8,
        TotalValTaxPayableRM25,
        TotalValTaxPayable,
        AmtDeductFrCreditNote,
        AmtDeductSalesTax,
        AmtDeductServiceTax,
        TotalValBadDebtRelief,
        AmtAdjustmentSalesTax,
        TotalTaxPayableB4Penalty,
        PenaltyRate,
        PenaltyAmt,
        TotalTaxPayableInclPenalty,
      } = sst;

      this.b1Details = detailsList;

      this.b211aValue = TotalValTaxablePerc5;
      this.b211bValue = TotalValTaxablePerc10;
      this.b211cValue = TotalValTaxablePerc6;
      this.b211dValue = TotalValTaxablePerc8 || 0;
      this.b211eValue = TotalUnitTaxableRM25;

      this.b211aCalcValue = TotalValTaxPayablePerc5;
      this.b211bCalcValue = TotalValTaxPayablePerc10;
      this.b211cCalcValue = TotalValTaxPayablePerc6;
      this.b211dCalcValue = TotalValTaxPayablePerc8 || 0;
      this.b211eCalcValue = TotalValTaxPayableRM25;

      this.b212Value = TotalValTaxPayable;

      this.b213aValue = AmtDeductFrCreditNote;
      this.b213bValue = AmtDeductSalesTax;
      this.b213cValue = AmtDeductServiceTax;
      this.b213dValue = TotalValBadDebtRelief || 0;

      this.b213AValue = AmtAdjustmentSalesTax;

      this.b214Value = TotalTaxPayableB4Penalty;
      this.b215RateValue = PenaltyRate ?? '0';
      this.calculateB2PenaltyTotalAmt(false);
      this.b215Value = PenaltyAmt || 0;
      this.b216Value = TotalTaxPayableInclPenalty;

      const {
        LitreRate,
        LitreSoldQty,
        LitreValTaxSales,
        LitreValTaxPayable,
        KGRate,
        KGSoldQty,
        KGValTaxSales,
        KGValTaxPayable,
        AdVolerumRate,
        AdVolValTaxSales,
        AdVolValTaxPayable,
      } = sst;

      this.c17LitreRate = LitreRate ?? 0;
      this.c17LitreQty = LitreSoldQty ?? 0;
      this.c17LitreSales = LitreValTaxSales ?? 0;
      this.c17LitrePayable = LitreValTaxPayable ?? 0;
      this.c17KilogramRate = KGRate ?? 0;
      this.c17KilogramQty = KGSoldQty ?? 0;
      this.c17KilogramSales = KGValTaxSales ?? 0;
      this.c17KilogramPayable = KGValTaxPayable ?? 0;
      this.c17VolRate = AdVolerumRate ?? 0;
      this.c17VolSales = AdVolValTaxSales ?? 0;
      this.c17VolPayable = AdVolValTaxPayable ?? 0;

      const {
        SalesExemptedExport,
        SalesExemptedSchA,
        SalesExemptedSchB,
        SalesExemptedSchC_Item1and2,
        SalesExemptedSchC_Item3and4,
        SalesExemptedSchC_Item5,
        TotalValExemptedTaxableServices,
        TotalValExemptedGroupRelief,
        TotalValPartialExemptedTaxableServices,
        TotalValNonTaxableServices,
        TotalValExemptedSubsection35,
      } = sst;

      this.d18aValue = SalesExemptedExport ?? 0;
      this.d18b1Value = SalesExemptedSchA ?? 0;
      this.d18b2Value = SalesExemptedSchB ?? 0;

      this.d18b3iValue = SalesExemptedSchC_Item1and2 ?? 0;
      this.d18b3iiValue = SalesExemptedSchC_Item3and4 ?? 0;
      this.d18b3iiiValue = SalesExemptedSchC_Item5 ?? 0;

      this.d18c1Value = this.$currencyFormat(TotalValExemptedTaxableServices ?? 0);
      this.d18c2Value = this.$currencyFormat(TotalValExemptedGroupRelief ?? 0);
      this.d18c3Value = this.$currencyFormat(TotalValPartialExemptedTaxableServices ?? 0);

      this.d18dValue = this.$currencyFormat(TotalValNonTaxableServices ?? 0);
      this.d18eValue = this.$currencyFormat(TotalValExemptedSubsection35 ?? 0);

      const { PersonExempted_Item1and2, PersonExempted_Item3and4, PersonExempted_Item5 } = sst;

      this.e19Value = PersonExempted_Item1and2 ?? 0;
      this.e20Value = PersonExempted_Item3and4 ?? 0;
      this.e21Value = PersonExempted_Item5 ?? 0;

      const { FillingDate, DeclarantName, DeclarantNRIC, DeclarantDesignation, DeclarantTelNo } = sst;

      this.f22Value = FillingDate ? new Date(FillingDate) : null;
      this.f23Value = DeclarantName ?? '';
      this.f24Value = DeclarantNRIC ?? '';
      this.f25Value = DeclarantDesignation ?? '';
      this.f26Value = DeclarantTelNo ?? '';

      this.$fullscreenLoading();
    },
    clearPopupEntryFields() {
      this.fillingNoValue = '';
      this.journalBatchNoValue = '';
      this.SSTRegistrationNoSalesValue = '';
      this.SSTRegistrationNoServiceValue = '';
      this.nameOfBusinessValue = '';
      this.returnDueDateValue = null;
      this.periodEndValueOverride = null;

      this.b1Details = [];

      this.b211aValue = 0;
      this.b211bValue = 0;
      this.b211cValue = 0;
      this.b211dValue = 0;
      this.b211eValue = 0;

      this.b211aCalcValue = 0;
      this.b211bCalcValue = 0;
      this.b211cCalcValue = 0;
      this.b211dCalcValue = 0;
      this.b211eCalcValue = 0;

      this.b212Value = 0;

      this.b213aValue = 0;
      this.b213bValue = 0;
      this.b213cValue = 0;
      this.b213dValue = 0;
      this.b213AValue = 0;

      this.b214Value = 0;
      this.b215RateValue = '0';
      this.b215Value = 0;
      this.b216Value = 0;

      this.c17LitreRate = 0;
      this.c17LitreQty = 0;
      this.c17LitreSales = 0;
      this.c17LitrePayable = 0;

      this.c17KilogramRate = 0;
      this.c17KilogramQty = 0;
      this.c17KilogramSales = 0;
      this.c17KilogramPayable = 0;

      this.c17VolRate = 0;
      this.c17VolSales = 0;
      this.c17VolPayable = 0;

      this.d18aValue = 0;
      this.d18b1Value = 0;
      this.d18b2Value = 0;

      this.d18b3iValue = 0;
      this.d18b3iiValue = 0;
      this.d18b3iiiValue = 0;

      this.d18c1Value = this.$currencyFormat('0');
      this.d18c2Value = this.$currencyFormat('0');
      this.d18c3Value = this.$currencyFormat('0');

      this.d18dValue = this.$currencyFormat('0');
      this.d18eValue = this.$currencyFormat('0');

      this.e19Value = 0;
      this.e20Value = 0;
      this.e21Value = 0;

      this.f22Value = null;
      this.f23Value = '';
      this.f24Value = '';
      this.f25Value = '';
      this.f26Value = '';
    },

    parseSSTXML(xmlString) {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, 'text/xml');
      const currSeperator = this.currencyFormatState.charAt(0);

      const getText = (tag) => xmlDoc.querySelector(tag)?.textContent ?? '';
      const getMoney = (tag) => {
        const get = xmlDoc.querySelector(tag)?.textContent || '0';
        const value = parseFloat(get.replaceAll(currSeperator, ''));
        return Number.isFinite(value) ? value : 0;
      };

      const returnObj = {
        // Header
        FillingNo: getText('txtFillingNo'),
        SalesTaxLicenseNo: getText('txtSalesTaxNo'),
        ServiceTaxLicenseNo: getText('txtServiceTaxNo'),
        CompanyName: getText('txtCompany'),
        TaxPeriodStartDate: getText('txtTaxablePeriodStart'),
        TaxPeriodEndDate: getText('txtTaxablePeriodEnd'),
        ReturnPaymentDueDate: getText('txtRetPaymentDueDate'),

        // Part B1
        TaxItemDesc1: getText('TaxItemDesc1'),
        TaxItemTariffCode1: getText('TaxItemTariffCode1'),
        ValofTaxGoods1: getMoney('ValofTaxGoods1'),
        ValofGoodsOwnUse1: getMoney('ValofGoodsOwnUse1'),
        ValTaxServices1: getMoney('ValTaxServices1'),
        TaxPayable1: getMoney('TaxPayable1'),
        AmtDeductCN1: getMoney('AmtDeductCN1'),
        TotalValExempted1: getMoney('TotalValExempted1'),

        TaxItemDesc2: getText('TaxItemDesc2'),
        TaxItemTariffCode2: getText('TaxItemTariffCode2'),
        ValofTaxGoods2: getMoney('ValofTaxGoods2'),
        ValofGoodsOwnUse2: getMoney('ValofGoodsOwnUse2'),
        ValTaxServices2: getMoney('ValTaxServices2'),
        TaxPayable2: getMoney('TaxPayable2'),
        AmtDeductCN2: getMoney('AmtDeductCN2'),
        TotalValExempted2: getMoney('TotalValExempted2'),

        TaxItemDesc3: getText('TaxItemDesc3'),
        TaxItemTariffCode3: getText('TaxItemTariffCode3'),
        ValofTaxGoods3: getMoney('ValofTaxGoods3'),
        ValofGoodsOwnUse3: getMoney('ValofGoodsOwnUse3'),
        ValTaxServices3: getMoney('ValTaxServices3'),
        TaxPayable3: getMoney('TaxPayable3'),
        AmtDeductCN3: getMoney('AmtDeductCN3'),
        TotalValExempted3: getMoney('TotalValExempted3'),

        TaxItemDesc4: getText('TaxItemDesc4'),
        TaxItemTariffCode4: getText('TaxItemTariffCode4'),
        ValofTaxGoods4: getMoney('ValofTaxGoods4'),
        ValofGoodsOwnUse4: getMoney('ValofGoodsOwnUse4'),
        ValTaxServices4: getMoney('ValTaxServices4'),
        TaxPayable4: getMoney('TaxPayable4'),
        AmtDeductCN4: getMoney('AmtDeductCN4'),
        TotalValExempted4: getMoney('TotalValExempted4'),

        TaxItemDesc5: getText('TaxItemDesc5'),
        TaxItemTariffCode5: getText('TaxItemTariffCode5'),
        ValofTaxGoods5: getMoney('ValofTaxGoods5'),
        ValofGoodsOwnUse5: getMoney('ValofGoodsOwnUse5'),
        ValTaxServices5: getMoney('ValTaxServices5'),
        TaxPayable5: getMoney('TaxPayable5'),
        AmtDeductCN5: getMoney('AmtDeductCN5'),
        TotalValExempted5: getMoney('TotalValExempted5'),

        TaxItemDesc6: getText('TaxItemDesc6'),
        TaxItemTariffCode6: getText('TaxItemTariffCode6'),
        ValofTaxGoods6: getMoney('ValofTaxGoods6'),
        ValofGoodsOwnUse6: getMoney('ValofGoodsOwnUse6'),
        ValTaxServices6: getMoney('ValTaxServices6'),
        TaxPayable6: getMoney('TaxPayable6'),
        AmtDeductCN6: getMoney('AmtDeductCN6'),
        TotalValExempted6: getMoney('TotalValExempted6'),

        TaxItemDesc7: getText('TaxItemDesc7'),
        TaxItemTariffCode7: getText('TaxItemTariffCode7'),
        ValofTaxGoods7: getMoney('ValofTaxGoods7'),
        ValofGoodsOwnUse7: getMoney('ValofGoodsOwnUse7'),
        ValTaxServices7: getMoney('ValTaxServices7'),
        TaxPayable7: getMoney('TaxPayable7'),
        AmtDeductCN7: getMoney('AmtDeductCN7'),
        TotalValExempted7: getMoney('TotalValExempted7'),

        TaxItemDesc8: getText('TaxItemDesc8'),
        TaxItemTariffCode8: getText('TaxItemTariffCode8'),
        ValofTaxGoods8: getMoney('ValofTaxGoods8'),
        ValofGoodsOwnUse8: getMoney('ValofGoodsOwnUse8'),
        ValTaxServices8: getMoney('ValTaxServices8'),
        TaxPayable8: getMoney('TaxPayable8'),
        AmtDeductCN8: getMoney('AmtDeductCN8'),
        TotalValExempted8: getMoney('TotalValExempted8'),

        TaxItemDesc9: getText('TaxItemDesc9'),
        TaxItemTariffCode9: getText('TaxItemTariffCode9'),
        ValofTaxGoods9: getMoney('ValofTaxGoods9'),
        ValofGoodsOwnUse9: getMoney('ValofGoodsOwnUse9'),
        ValTaxServices9: getMoney('ValTaxServices9'),
        TaxPayable9: getMoney('TaxPayable9'),
        AmtDeductCN9: getMoney('AmtDeductCN9'),
        TotalValExempted9: getMoney('TotalValExempted9'),

        TaxItemDesc10: getText('TaxItemDesc10'),
        TaxItemTariffCode10: getText('TaxItemTariffCode10'),
        ValofTaxGoods10: getMoney('ValofTaxGoods10'),
        ValofGoodsOwnUse10: getMoney('ValofGoodsOwnUse10'),
        ValTaxServices10: getMoney('ValTaxServices10'),
        TaxPayable10: getMoney('TaxPayable10'),
        AmtDeductCN10: getMoney('AmtDeductCN10'),
        TotalValExempted10: getMoney('TotalValExempted10'),

        // Part B2
        TotalValTaxablePerc5: getMoney('txtTotalValTaxablePerc5'),
        TotalValTaxPayablePerc5: getMoney('txtTotalValTaxPayablePerc5'),
        TotalValTaxablePerc10: getMoney('txtTotalValTaxablePerc10'),
        TotalValTaxPayablePerc10: getMoney('txtTotalValTaxPayablePerc10'),
        TotalValTaxablePerc6: getMoney('txtTotalValTaxablePerc6'),
        TotalValTaxPayablePerc6: getMoney('txtTotalValTaxPayablePerc6'),
        TotalValTaxablePerc8: getMoney('txtTotalValTaxablePerc8'),
        TotalValTaxPayablePerc8: getMoney('txtTotalValTaxPayablePerc8'),
        TotalUnitTaxableRM25: getMoney('txtTotalUnitTaxableRM25'),
        TotalValTaxPayableRM25: getMoney('txtTotalValTaxPayableRM25'),
        TotalValTaxPayable: getMoney('txtTotalValTaxPayable'),
        AmtDeductFrCreditNote: getMoney('txtAmtDeductFrCreditNote'),
        TotalValBadDebtRelief: getMoney('txtTotalValBadDebtRelief'),
        AmtDeductSalesTax: getMoney('txtAmtDeductSalesTax'),
        AmtDeductServiceTax: getMoney('txtAmtDeductServiceTax'),
        AmtAdjustmentSalesTax: getMoney('txtAmtAdjustmentSalesTax'),
        TotalTaxPayableB4Penalty: getMoney('txtTotalTaxPayableB4Penalty'),
        PenaltyRate: getMoney('txtPenaltyRate'),
        PenaltyAmt: getMoney('txtPenaltyAmt'),
        TotalTaxPayableInclPenalty: getMoney('txtTotalTaxPayableInclPenalty'),

        // Part C
        LitreRate: getMoney('txtLitreRate'),
        LitreSoldQty: getMoney('txtLitreSoldQty'),
        LitreValTaxSales: getMoney('txtLitreValTaxSales'),
        LitreValTaxPayable: getMoney('txtLitreValTaxPayable'),
        KGRate: getMoney('txtKGRate'),
        KGSoldQty: getMoney('txtKGSoldQty'),
        KGValTaxSales: getMoney('txtKGValTaxSales'),
        KGValTaxPayable: getMoney('txtKGValTaxPayable'),
        AdVolerumRate: getMoney('txtAdVolerumRate'),
        AdVolValTaxSales: getMoney('txtAdVolValTaxSales'),
        AdVolValTaxPayable: getMoney('txtAdVolValTaxPayable'),

        // Part D
        SalesExemptedExport: getMoney('txtSalesExemptedExport'),
        SalesExemptedSchA: getMoney('txtSalesExemptedSchA'),
        SalesExemptedSchB: getMoney('txtSalesExemptedSchB'),
        SalesExemptedSchC_Item1and2: getMoney('txtSalesExemptedSchC_Item1and2'),
        SalesExemptedSchC_Item3and4: getMoney('txtSalesExemptedSchC_Item3and4'),
        SalesExemptedSchC_Item5: getMoney('txtSalesExemptedSchC_Item5'),
        TotalValExemptedTaxableServices: getMoney('txtTotalValExemptedTaxableServices'),
        TotalValExemptedGroupRelief: getMoney('txtTotalValExemptedGroupRelief'),
        TotalValPartialExemptedTaxableServices: getMoney('txtTotalValExemptedOthExemption'),
        TotalValNonTaxableServices: getMoney('txtTotalValExemptedNonTaxableServices'),
        TotalValExemptedSubsection35: getMoney('txtTotalValExemptedSubsection35'),

        // Part E
        PersonExempted_Item1and2: getMoney('txtPersonExempted_Item1and2'),
        PersonExempted_Item3and4: getMoney('txtPersonExempted_Item3and4'),
        PersonExempted_Item5: getMoney('txtPersonExempted_Item5'),

        // Part F
        FillingDate: getText('dtDate'),
        DeclarantName: getText('txtDeclarantName'),
        DeclarantNRIC: getText('MskNRICNo'),
        DeclarantDesignation: getText('txtDeclarantDesignation'),
        DeclarantTelNo: getText('txtDeclarantTelNo'),
      };

      return returnObj;
    },

    calculateB2PenaltyTotalPercent(e) {
      if (e) return;

      const taxPayable = this.toSSTNumber(this.b214Value);
      const penaltyRate = Number(this.b215RateValue ?? 0);

      this.b215Value = (taxPayable * penaltyRate) / 100;
    },
    calculateB2PenaltyTotalAmt(e) {
      if (e) return;

      const taxPayable = this.toSSTNumber(this.b214Value);
      const penaltyAmt = this.toSSTNumber(this.b215Value);
      if (taxPayable == 0) return;

      this.b215RateValue = parseFloat(((penaltyAmt / taxPayable) * 100).toFixed(2)).toString();
    },

    async popupSave() {
      this.$fullscreenLoading('Saving SST Return');
      const xmlString = this.buildXml();

      const zeroCurr = this.$currencyFormat('0');

      const responseBody = {
        totalvaltaxpayable: this.b212Value ?? zeroCurr,
        amtdeductfrcreditnote: this.b213aValue ?? zeroCurr,
        penaltyamt: this.b215Value ?? zeroCurr,
        totaltaxpayableinclpenalty: this.b216realTotal ?? zeroCurr,
        sstdetails: xmlString,
        fillingno: this.fillingNoValue,
        fillingdate: (this.f22Value ?? new Date()).formatString('yyyy-MM-dd'),
      };

      const result = await this.$apiCallV2('/SSTReturn/SaveSSTReturn', { ...responseBody });
      const { Results, ErrMsg, fillingno } = result?.[0] || {};

      if (Results == '1') {
        this.entryError.push(ErrMsg);
        this.$fullscreenLoading();
        return;
      }

      this.viewMode = true;
      this.menuMode = 'View';
      this.entrySuccess.push(ErrMsg);
      await this.populatePopupEntry(fillingno);
      await this.GetSSTReturnList();
      this.$fullscreenLoading();
    },

    buildXml() {
      let xml = '<SST02Return>';

      // Header
      xml += `<txtFillingNo>${this.fillingNoValue ?? ''}</txtFillingNo>`;
      xml += `<txtSalesTaxNo>${this.SSTRegistrationNoSalesValue ?? ''}</txtSalesTaxNo>`;
      xml += `<txtServiceTaxNo>${this.SSTRegistrationNoServiceValue ?? ''}</txtServiceTaxNo>`;
      xml += `<txtCompany>${this.nameOfBusinessValue ?? ''}</txtCompany>`;
      xml += `<txtTaxablePeriodStart>${this.periodStartValue.formatString('yyyy-MM-dd') ?? ''}</txtTaxablePeriodStart>`;
      xml += `<txtTaxablePeriodEnd>${this.periodEndValue.formatString('yyyy-MM-dd') ?? ''}</txtTaxablePeriodEnd>`;
      xml += `<txtRetPaymentDueDate>${this.returnDueDateValue.formatString('yyyy-MM-dd') ?? ''}</txtRetPaymentDueDate>`;

      // Part B1
      for (let n = 1; n <= 10; n++) {
        const hasRow = this.b1Details[n - 1] !== undefined;

        if (n === 1 && !hasRow) {
          xml += `<TaxItemDesc${n}>-</TaxItemDesc${n}>`;
          xml += `<TaxItemTariffCode${n}>-</TaxItemTariffCode${n}>`;
          xml += `<ValofTaxGoods${n}>0</ValofTaxGoods${n}>`;
          xml += `<ValofGoodsOwnUse${n}>0</ValofGoodsOwnUse${n}>`;
          xml += `<ValTaxServices${n}>0</ValTaxServices${n}>`;
          xml += `<TaxPayable${n}>0</TaxPayable${n}>`;
          xml += `<AmtDeductCN${n}>0</AmtDeductCN${n}>`;
          xml += `<TotalValExempted${n}>0</TotalValExempted${n}>`;
        } else {
          const {
            'Tax Goods/Service Desc': taxItemDesc = '',
            'Tariff Code/Service Code': taxItemTariffCode = '',
            'Val of Tax Goods Sold/Work Performed': valOfTaxGoods = '',
            'Val of Goods Own Used/Disposed/Free Services': valOfGoodsOwnUse = '',
            'Val of Tax Services': valTaxServices = '',
            'Tax Payable': taxPayable = '',
            'Tax Deduct fr CN': amtDeductCN = '',
            'Tax Exempted': totalValExempted = '',
          } = this.b1Details[n - 1] || {};

          xml += `<TaxItemDesc${n}>${taxItemDesc}</TaxItemDesc${n}>`;
          xml += `<TaxItemTariffCode${n}>${taxItemTariffCode}</TaxItemTariffCode${n}>`;
          xml += `<ValofTaxGoods${n}>${valOfTaxGoods}</ValofTaxGoods${n}>`;
          xml += `<ValofGoodsOwnUse${n}>${valOfGoodsOwnUse}</ValofGoodsOwnUse${n}>`;
          xml += `<ValTaxServices${n}>${valTaxServices}</ValTaxServices${n}>`;
          xml += `<TaxPayable${n}>${taxPayable}</TaxPayable${n}>`;
          xml += `<AmtDeductCN${n}>${amtDeductCN}</AmtDeductCN${n}>`;
          xml += `<TotalValExempted${n}>${totalValExempted}</TotalValExempted${n}>`;
        }
      }

      // Part B2
      xml += `<txtTotalValTaxablePerc5>${this.b211aValue ?? ''}</txtTotalValTaxablePerc5>`;
      xml += `<txtTotalValTaxPayablePerc5>${this.b211aCalcValue ?? ''}</txtTotalValTaxPayablePerc5>`;
      xml += `<txtTotalValTaxablePerc10>${this.b211bValue ?? ''}</txtTotalValTaxablePerc10>`;
      xml += `<txtTotalValTaxPayablePerc10>${this.b211bCalcValue ?? ''}</txtTotalValTaxPayablePerc10>`;
      xml += `<txtTotalValTaxablePerc6>${this.b211cValue ?? ''}</txtTotalValTaxablePerc6>`;
      xml += `<txtTotalValTaxPayablePerc6>${this.b211cCalcValue ?? ''}</txtTotalValTaxPayablePerc6>`;
      xml += `<txtTotalValTaxablePerc8>${this.b211dValue ?? ''}</txtTotalValTaxablePerc8>`;
      xml += `<txtTotalValTaxPayablePerc8>${this.b211dCalcValue ?? ''}</txtTotalValTaxPayablePerc8>`;
      xml += `<txtTotalUnitTaxableRM25>${this.b211eValue ?? ''}</txtTotalUnitTaxableRM25>`;
      xml += `<txtTotalValTaxPayableRM25>${this.b211eCalcValue ?? ''}</txtTotalValTaxPayableRM25>`;
      xml += `<txtTotalValTaxPayable>${this.b212Value ?? ''}</txtTotalValTaxPayable>`;
      xml += `<txtAmtDeductFrCreditNote>${this.b213aValue ?? ''}</txtAmtDeductFrCreditNote>`;
      xml += `<txtAmtDeductSalesTax>${this.b213bValue ?? ''}</txtAmtDeductSalesTax>`;
      xml += `<txtAmtDeductServiceTax>${this.b213cValue ?? ''}</txtAmtDeductServiceTax>`;
      xml += `<txtTotalValBadDebtRelief>${this.b213dValue ?? ''}</txtTotalValBadDebtRelief>`;
      xml += `<txtAmtAdjustmentSalesTax>${this.b213AValue ?? ''}</txtAmtAdjustmentSalesTax>`;
      xml += `<txtTotalTaxPayableB4Penalty>${this.b214Value ?? ''}</txtTotalTaxPayableB4Penalty>`;
      xml += `<txtPenaltyRate>${this.b215RateValue ?? ''}</txtPenaltyRate>`;
      xml += `<txtPenaltyAmt>${this.b215Value ?? ''}</txtPenaltyAmt>`;
      xml += `<txtTotalTaxPayableInclPenalty>${this.b216realTotal ?? ''}</txtTotalTaxPayableInclPenalty>`;

      // Part C
      xml += `<txtLitreRate>${this.c17LitreRate ?? ''}</txtLitreRate>`;
      xml += `<txtLitreSoldQty>${this.c17LitreQty ?? ''}</txtLitreSoldQty>`;
      xml += `<txtLitreValTaxSales>${this.c17LitreSales ?? ''}</txtLitreValTaxSales>`;
      xml += `<txtLitreValTaxPayable>${this.c17LitrePayable ?? ''}</txtLitreValTaxPayable>`;
      xml += `<txtKGRate>${this.c17KilogramRate ?? ''}</txtKGRate>`;
      xml += `<txtKGSoldQty>${this.c17KilogramQty ?? ''}</txtKGSoldQty>`;
      xml += `<txtKGValTaxSales>${this.c17KilogramSales ?? ''}</txtKGValTaxSales>`;
      xml += `<txtKGValTaxPayable>${this.c17KilogramPayable ?? ''}</txtKGValTaxPayable>`;
      xml += `<txtAdVolerumRate>${this.c17VolRate ?? ''}</txtAdVolerumRate>`;
      xml += `<txtAdVolValTaxSales>${this.c17VolSales ?? ''}</txtAdVolValTaxSales>`;
      xml += `<txtAdVolValTaxPayable>${this.c17VolPayable ?? ''}</txtAdVolValTaxPayable>`;

      // Part D
      xml += `<txtSalesExemptedExport>${this.d18aValue ?? ''}</txtSalesExemptedExport>`;
      xml += `<txtSalesExemptedSchA>${this.d18b1Value ?? ''}</txtSalesExemptedSchA>`;
      xml += `<txtSalesExemptedSchB>${this.d18b2Value ?? ''}</txtSalesExemptedSchB>`;
      xml += `<txtSalesExemptedSchC_Item1and2>${this.d18b3iValue ?? ''}</txtSalesExemptedSchC_Item1and2>`;
      xml += `<txtSalesExemptedSchC_Item3and4>${this.d18b3iiValue ?? ''}</txtSalesExemptedSchC_Item3and4>`;
      xml += `<txtSalesExemptedSchC_Item5>${this.d18b3iiiValue ?? ''}</txtSalesExemptedSchC_Item5>`;
      xml += `<txtTotalValExemptedTaxableServices>${this.d18c1Value ?? ''}</txtTotalValExemptedTaxableServices>`;
      xml += `<txtTotalValExemptedGroupRelief>${this.d18c2Value ?? ''}</txtTotalValExemptedGroupRelief>`;
      xml += `<txtTotalValExemptedOthExemption>${this.d18c3Value ?? ''}</txtTotalValExemptedOthExemption>`;
      xml += `<txtTotalValExemptedNonTaxableServices>${this.d18dValue ?? ''}</txtTotalValExemptedNonTaxableServices>`;
      xml += `<txtTotalValExemptedSubsection35>${this.d18eValue ?? ''}</txtTotalValExemptedSubsection35>`;

      // Part E
      xml += `<txtPersonExempted_Item1and2>${this.e19Value ?? ''}</txtPersonExempted_Item1and2>`;
      xml += `<txtPersonExempted_Item3and4>${this.e20Value ?? ''}</txtPersonExempted_Item3and4>`;
      xml += `<txtPersonExempted_Item5>${this.e21Value ?? ''}</txtPersonExempted_Item5>`;

      // Part F
      xml += `<dtDate>${(this.f22Value ?? new Date()).formatString('yyyy-MM-dd') ?? ''}</dtDate>`;
      xml += `<txtDeclarantName>${this.f23Value ?? ''}</txtDeclarantName>`;
      xml += `<MskNRICNo>${this.f24Value ?? ''}</MskNRICNo>`;
      xml += `<txtDeclarantDesignation>${this.f25Value ?? ''}</txtDeclarantDesignation>`;
      xml += `<txtDeclarantTelNo>${this.f26Value ?? ''}</txtDeclarantTelNo>`;

      xml += '</SST02Return>';

      // Replace invalid characters
      xml = xml.replaceAll(/"/g, '&quot;');
      xml = xml.replaceAll(/'/g, '&apos;');
      xml = xml.replaceAll(/&(?!(quot|apos|amp|lt|gt);)/g, '&amp;');

      return `<?xml version="1.0" ?>${xml}`;
    },

    popupCancel(e) {
      if (e) return;
      this.$fullscreenLoading('Canceling');
      this.cancelSST();
      this.$fullscreenLoading();
    },

    async cancelSST() {
      if (!(this.menuMode == 'New' && this.fillingNoValue && this.popupEntryOpen)) return;
      const result = await this.$apiCallV2('/SSTReturn/CancelSSTReturn', { fillingno: this.fillingNoValue });
      const { Result, ErrMsg } = result[0];
      if (Result == '1') {
        this.$showAlert('error', 'SST Return Failed To Be Cancelled', ErrMsg, [{ text: 'OK' }]);
      }
    },

    // fetch API

    async checkSSTPeriod() {
      if (!this.periodStartValue || !this.periodEndValue) {
        // eslint-disable-next-line no-console
        console.error(this.periodStartValue, this.periodEndValue);
        return;
      }
      const result = await this.$apiCallV2('/SSTReturn/CheckSSTPeriod', {
        startdate: this.periodStartValue,
        enddate: this.periodEndValue,
      });

      return result[0];
    },

    async getSSTReturns() {
      if (!this.periodStartValue || !this.periodEndValue) {
        // eslint-disable-next-line no-console
        console.error(this.periodStartValue, this.periodEndValue);
        return;
      }
      const result = await this.$apiCallV2('/SSTReturn/GetSSTReturns', {
        startdate: this.periodStartValue.formatString('yyyy-MM-dd'),
        enddate: this.periodEndValue.formatString('yyyy-MM-dd'),
      });

      return result[0];
    },

    async getSSTDetails() {
      const result = await this.$apiCallV2('/SSTReturn/GetSSTDetails', {});
      this.SSTDetails = (await result?.[0]) ?? null;
    },

    async getSSTReturnsDetail(fillingno) {
      const result = await this.$apiCallV2('/SSTReturn/GetSSTReturnsDetail', { fillingno: fillingno });
      return result[0].SST02Details;
    },

    async GetSSTReturnList() {
      this.SSTListTableLoading = true;
      const result = await this.$apiCallV2('/SSTReturn/GetSSTReturnList', {
        startdate: this.listStartDate?.formatString('yyyy-MM-dd') ?? null,
        enddate: this.listEndDate?.formatString('yyyy-MM-dd') ?? null,
      });

      const filterResult = result.map((item, index) => {
        const {
          FillingNo,
          FillingDate,
          FillingPeriodFrom,
          FillingPeriodTo,
          TotalValTaxPayable,
          AmtDeductFrCreditNote,
          PenaltyAmt,
          TotalTaxPayableInclPenalty,
          Remarks1,
          UserCreated,
          DateCreated,
          UserID,
          DateUpdated,
        } = item;

        return {
          '#': index + 1,
          'Filling No': FillingNo,
          'Filling Date': FillingDate ?? null,
          'Period Start Date': FillingPeriodFrom ?? null,
          'Period End Date': FillingPeriodTo ?? null,
          'Tax Payable': TotalValTaxPayable ?? '',
          'Amt Deduct Fr Credit Note': AmtDeductFrCreditNote ?? '',
          'Penalty Amt': PenaltyAmt ?? '',
          'Total Payable Incl Penalty': TotalTaxPayableInclPenalty ?? '',
          Remarks: Remarks1 ?? '',
          'User Created': UserCreated ?? '',
          'Date Created': DateCreated ?? null,
          'User Updated': UserID ?? '',
          'Date Updated': DateUpdated ?? null,
        };
      });

      this.listStartDateActive = this.listStartDate?.formatString('yyyy-MM-dd') ?? null;
      this.listEndDateActive = this.listEndDate?.formatString('yyyy-MM-dd') ?? null;

      this.SSTListTableData = [];
      this.$nextTick(() => {
        this.SSTListTableData = filterResult ?? [];
        this.SSTListTableLoading = false;
      });
    },

    handleUnload() {
      this.cancelSST();
    },
  },
  async mounted() {
    this.$fullscreenLoading('Getting SST List');
    await Promise.all([this.getSSTDetails()]);
    await this.GetSSTReturnList();

    this.$fullscreenLoading();

    window.addEventListener('beforeunload', this.handleUnload);
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.main {
  font-size: 0.75rem;
  padding: 10px 45px;
  padding-right: 4px;

  display: flex;
  gap: 4px;

  width: 100%;
  height: 100%;
}
.listing-container {
  padding-top: 0;
  width: 100%;
  height: 100%;

  min-width: 0;

  display: flex;
  gap: 4px;
  flex-direction: column;
  > * {
    min-height: 0;
  }

  .sst-status {
    background-color: white;
    padding: 8px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .acc-health {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .filter {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
  .sst-table {
    background-color: white;
    padding: 8px;
    border-radius: 5px;
  }
}

.validate-popup {
  position: fixed;
  z-index: 9999;
  background: rgba(0, 0, 0, 50%);
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  .validate-popup-inner {
    background: white;
    height: 100%;
    max-height: 680px;
    width: 100%;
    max-width: 1200px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;
    top: 20px;
    padding: 8px;
    border-radius: 5px;
    > * {
      min-height: 0;
    }
  }
}

.filter-section {
  max-width: 600px;
}

.popup-entry-main {
  padding-right: 4px;
}

.tab-component {
  display: flex;
  flex-direction: column;
  min-width: 0;
  .tab-container {
    padding: 4px;
  }
}

.flex-container {
  display: flex;
  gap: 8px;
}

.form-container {
  max-width: 1200px;
  padding-top: 8px;
}
.grid-form {
  display: grid;
  gap: 16px;
  margin-bottom: 4px;
  align-items: center;

  &.partA {
    grid-template-columns: 2fr 3fr 3fr;
  }

  &.partB2 {
    grid-template-columns: 28px 12fr 1fr 8fr 2fr 1fr 8fr;
  }

  &.partC {
    grid-template-columns: 28px 80px 40px 1fr 100px 1fr 1fr 1fr;
  }

  &.partD {
    grid-template-columns: 28px 28px 28px 28px auto 40px 200px;
  }

  &.partE {
    grid-template-columns: 28px auto 40px 200px;
  }
  &.partF {
    grid-template-columns: 28px 220px 1fr 2fr;
  }
}

.period-popup {
  &:has(.date-time-box .calendar) {
    min-height: 14rem;
  }
}
</style>
